/**
 * A period import's page is addressed by its period rather than its id (`…/ip-accruals/2026/09`,
 * `…/bpc-actuals/2026`): each import is unique per period, so the URL reads as what it shows and can be
 * typed or edited by hand.
 */
export type CrtPeriodParams = { year: string; month: string }
export type CrtYearParams = { year: string }

const YEAR_PATTERN = /^\d{4}$/
const MONTH_PATTERN = /^(0[1-9]|1[0-2])$/

/** `'2026-09-01'` → `{ year: '2026', month: '09' }` */
export function crtPeriodToParams(crtPeriod: string): CrtPeriodParams {
  const [year = '', month = ''] = crtPeriod.split('-')
  return { year, month }
}

/** `{ year: '2026', month: '09' }` → `'2026-09-01'`, or null when the URL holds no valid period. */
export function crtPeriodFromParams({ year, month }: CrtPeriodParams): string | null {
  return YEAR_PATTERN.test(year) && MONTH_PATTERN.test(month) ? `${year}-${month}-01` : null
}

export function crtYearToParams(year: number): CrtYearParams {
  return { year: String(year) }
}

/** The year a URL names, or null when it holds no valid year. */
export function crtYearFromParams({ year }: CrtYearParams): number | null {
  return YEAR_PATTERN.test(year) ? Number(year) : null
}
